import React from 'react';

import classes from './Contacts.module.scss';

import Mail from '../assets/Social/mail2.svg';
import Github from '../assets/Social/github1.svg';
import Linkedin from '../assets/Social/linkedin.svg';
import Phone from '../assets/Social/phone.svg';

const Contacts = () => {
    return (
        <div className={classes.ScrollSnap} id='contact'>
            <div className={classes.Header}>
                <h1>Contact</h1>
            </div>
            <div className={classes.ContactContainer}>
                <section>
                    <a href="mailto:iparthpakhare@gmail.com">
                        <img src={Mail} alt="Mail"/><p>iparthpakhare@gmail.com</p>
                    </a>
                    <a href="https://github.com/parthpakhare" target="_blank" rel="noreferrer">
                        <img src={Github} alt="Github"/><p>github.com/parthpakhare</p>
                    </a>
                    <a href="https://www.linkedin.com/in/parth-p-b779261a4" target="_blank" rel="noreferrer">
                        <img src={Linkedin} alt="LinkedIn"/><p>linkedin.com/in/parth-p-b779261a4</p>
                    </a>
                    <a href="tel:9967117679">
                        <img src={Phone} alt="Phone"/><p>+91 - 99671 - 17679</p>
                    </a>
                    <a href="https://drive.google.com/file/d/1ahFaWpYdh2od38f_0I8sssftLVhvnX7H/view?usp=sharing.pdf" download="ParthResume .pdf" target='_blank' rel='noreferrer' >
                        <button>DOWNLOAD RESUME</button>
                    </a>
                </section>

                

            </div>
        </div>
    )
}

export default Contacts;
